// src/api/workflow.ts
import { opsHttp } from "../auth/apiClient.ts";
import { opOk, opData, opError } from "./_opResult.ts";
import type {
  SaveOrderRequest,
  CloseOrderRequest,
  AddInvoiceRequest,
  AddTopupRequest,
  AddRefundRequest,
  ExchangeOrderDto,
} from "./dto";
import type { Id } from "./_opResult.ts"; // <-- вот так

// остальной файл без изменений…


/** Создание/сохранение ордера */
export async function saveOrder<TOrder extends ExchangeOrderDto = ExchangeOrderDto>(
  req: SaveOrderRequest
): Promise<{ ok: true; order: TOrder } | { ok: false; error: string }> {
  const { data } = await opsHttp.post(`/api/Workflow/order/save`, req);
  return opOk<TOrder>(data) ? { ok: true, order: opData<TOrder>(data)! } : { ok: false, error: opError(data) };
}

/** Закрыть ордер */
export async function closeOrder(
  req: CloseOrderRequest
): Promise<{ ok: true } | { ok: false; error: string }> {
  const { data } = await opsHttp.post(`/api/Workflow/order/close`, req);
  return opOk(data) ? { ok: true } : { ok: false, error: opError(data) };
}

/** Закрепить ордер */
export async function pin(orderId: Id): Promise<boolean> {
  const res = await opsHttp.post(`/api/Workflow/pin/${orderId}`);
  return res.status >= 200 && res.status < 300;
}

/** Открепить ордер */
export async function unpin(orderId: Id): Promise<boolean> {
  const res = await opsHttp.delete(`/api/Workflow/pin/${orderId}`);
  return res.status >= 200 && res.status < 300;
}

/** Добавить платёж (инвойс) */
export async function addInvoice(
  req: AddInvoiceRequest
): Promise<{ ok: true; id: Id } | { ok: false; error: string }> {
  const { data } = await opsHttp.post(`/api/Workflow/invoice/add`, req);
  return opOk<Id>(data) ? { ok: true, id: opData<Id>(data)! } : { ok: false, error: opError(data) };
}

/** Добавить добив */
export async function addTopup(
  { orderId, amount }: AddTopupRequest
): Promise<{ ok: true } | { ok: false; error: string }> {
  const { data } = await opsHttp.post(`/api/Workflow/order/topup`, { orderId, amount });
  return opOk(data) ? { ok: true } : { ok: false, error: opError(data) };
}

/** Добавить возврат */
export async function addRefund(
  { orderId, amount }: AddRefundRequest
): Promise<{ ok: true } | { ok: false; error: string }> {
  const { data } = await opsHttp.post(`/api/Workflow/order/refund`, { orderId, amount });
  return opOk(data) ? { ok: true } : { ok: false, error: opError(data) };
}
